export default __webpack_public_path__ + "static/bubblewrap-a1b82010dc814a70d0f572996984e5d1.png";